export const bannersConstants = {
    BANNERS_GET_REQUEST: 'BANNERS_GET_REQUEST',
    BANNERS_GET_SUCCESS: 'BANNERS_GET_SUCCESS',
    BANNERS_GET_FAILURE: 'BANNERS_GET_FAILURE'
};
